import React, { useEffect, useState } from 'react'
import Moment from 'moment'
import { 
  Row,
  Col,
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form, FormText, FormGroup, Label, Input
} from 'reactstrap'
import _ from 'lodash'
import DatePicker from 'react-datepicker'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import { EducationDefaultValue, EducationFieldData } from '../../assets'

const FormContent = ({
  open,
  onLoadEducation,
  
  onClose,
  selectedFormData,
  onClickSubmit
}) => {

  const [ educationFormData, onChangeEducationData ] = useState( EducationDefaultValue )

  useEffect(() => { 
    if ( !open ){
      onChangeEducationData( EducationDefaultValue )
    }
  }, [open])

  useEffect(() => {
    onChangeEducationData( selectedFormData )
  }, [ selectedFormData ])

  const onChangeEducationField = ( key, val ) => {
    let tmp = _.cloneDeep( educationFormData )
    tmp[ key ] = val
    return onChangeEducationData( tmp )
  }

  return (
    <Modal
      isOpen={ open }
      size={ 'xl' }>
      <ModalHeader toggle={() => onClose()}>{ `Edit Education` }</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <Row>
          {
            EducationFieldData.map( item => (
              <Col key={ item.value } lg={ item.col || 12 }>
                <FormGroup>
                  { 
                    item.label && (
                      <Label>
                        { `${ item.label } ` }
                        { item.required && <span className="text-danger">*</span> }
                      </Label>
                  )}
                  {
                    item.type === 'select' && (
                      <Input
                        type={ item.type }
                        value={ educationFormData[ item.value ] }
                        onChange={ e =>  onChangeEducationField( item.value, e.target.value )}
                        >
                        <option value=""></option>
                        { 
                          item.options.map( option => (
                            <option key={ option.name } value={ option.name }>{ option.name }</option>
                          ))
                        }
                      </Input>
                    )
                  }
                  {
                    ( item.type !== 'select' && item.type !== 'date' ) && (
                      <Input
                        type={ item.type }
                        value={ educationFormData[ item.value ] }
                        onChange={ e => onChangeEducationField( item.value, e.target.value )}/>
                    )
                  }
                  {
                    item.type === 'date' && (
                      <DatePicker
                        className={ 'w-100' }
                        dateFormat="dd-MM-yyyy"
                        selected={ educationFormData[ item.value ] }
                        onChange={ val => onChangeEducationField( item.value, val )}
                      />
                    )
                  }
                  { item.subLabel && <FormText>{ item.subLabel }</FormText> }
                </FormGroup>
              </Col>
            ))
          }
          </Row>
        </Form>
        { onLoadEducation && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button 
          className="mr-2"
          color={ 
            (EducationFieldData.some( item => item.required && !educationFormData[ item.value ])) 
              ? 'secondary' 
              : 'primary' 
          }
          disabled={ EducationFieldData.some( item => item.required && !educationFormData[ item.value ])}
          onClick={() => {
            onClickSubmit({
              ... educationFormData,
              cgpa: +educationFormData.cgpa,
              start_date: Moment( educationFormData.start_date ).format(),
              end_date: Moment( educationFormData.end_date ).format()
            })
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FormContent